export const ADMIN_NOTIFICATION_SETTINGS_DEFAULT = Object.freeze({
  purchases: true,
  services: true,
  services_external: true,
  occurrences: true,
  inspections: true,
  veterinary: true,
  pastures: true,
});

export const ADMIN_NOTIFICATION_MODULE_META = Object.freeze({
  purchases: { label: "Compras", description: "Pedidos e mudanças de status de compras." },
  services: { label: "Serviços Internos", description: "Criação e atualização de status dos serviços internos." },
  services_external: { label: "Serviços Terceirizados", description: "Criação e atualização de status dos terceirizados." },
  occurrences: { label: "Ocorrências", description: "Criação e atualização de status das ocorrências." },
  inspections: { label: "Vistorias", description: "Abertura e resultado final das vistorias." },
  veterinary: { label: "Veterinário", description: "Atendimentos veterinários individuais e em lote." },
  pastures: { label: "Localização", description: "Alertas de atualização de altura e risco de superlotação nos locais/pastagens." },
});

export function normalizeAdminNotificationSettings(input) {
  const base = input && typeof input === "object" ? input : {};
  return {
    ...ADMIN_NOTIFICATION_SETTINGS_DEFAULT,
    ...base,
    purchases: base.purchases !== false,
    services: base.services !== false,
    services_external: base.services_external !== false,
    occurrences: base.occurrences !== false,
    inspections: base.inspections !== false,
    veterinary: base.veterinary !== false,
    pastures: base.pastures !== false,
  };
}

export function isAdminNotificationEnabled(configLike, moduleKey) {
  const settings = normalizeAdminNotificationSettings(configLike?.notificationSettings || configLike);
  return settings[String(moduleKey || "").trim()] !== false;
}
